import dayjs from 'dayjs';

export type ChecklistSyncJobStatus =
  | 'PENDING'
  | 'RUNNING'
  | 'COMPLETED'
  | 'FAILED';

/** A queued or finished run of "sync this global checklist down to its loans". */
export interface ChecklistSyncJob {
  id: string;
  checklistRuleId: string;
  status: ChecklistSyncJobStatus;
  requestedByUserId?: string | null;
  loansTotal: number;
  loansProcessed: number;
  rulesAdded: number;
  rulesUpdated: number;
  resultsCleared: number;
  lastError?: string | null;
  startedAt?: string | null;
  finishedAt?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export const isChecklistSyncInFlight = (
  job?: ChecklistSyncJob | null,
): boolean => job?.status === 'PENDING' || job?.status === 'RUNNING';

export const SYNC_TIMESTAMP_FORMAT = 'MM/DD/YYYY hh:mm:ss A';

export const formatSyncTimestamp = (value?: string | null): string =>
  value && dayjs(value).isValid()
    ? dayjs(value).format(SYNC_TIMESTAMP_FORMAT)
    : '';

/** When a finished sync actually completed, falling back to the row's own timestamps. */
export const syncCompletedAt = (job: ChecklistSyncJob): string =>
  formatSyncTimestamp(job.finishedAt ?? job.updatedAt);
